import {
  FETCH_MESSAGES_REQUEST,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILURE,
  FETCH_UNREAD_COUNT_SUCCESS,
  MARK_MESSAGE_READ_SUCCESS,
  MARK_ALL_READ_SUCCESS
} from './actions';

const initialState = {
  list: [],
  loading: false,
  error: null,
  unreadCount: 0
};

export const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null
      };

    case FETCH_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload.unread_count
      };

    case MARK_MESSAGE_READ_SUCCESS:
      return {
        ...state,
        unreadCount: Math.max(0, state.unreadCount - 1),
        list: state.list.map(msg =>
          msg.id === action.payload.id
            ? { ...msg, is_read: true, read_at: action.payload.read_at }
            : msg
        )
      };

    case MARK_ALL_READ_SUCCESS:
      return {
        ...state,
        unreadCount: 0,
        list: state.list.map(msg => ({ ...msg, is_read: true }))
      };

    default:
      return state;
  }
};
